module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Brima Medical Bureau","short_name":"Brima Med","start_url":"/","background_color":"#AFDEF2","theme_color":"#AFDEF2","display":"minimal-ui","icon":"src/images/brima-med-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"084cc84f0133a62c19d38299b2f39cbb"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
